"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userInfo = exports.codeExchange = exports.parseAuthorizeOptionsFromUrl = exports.buildAuthorizeURL = exports.buildLogoutURL = exports.OpenIDConfigurationManager = exports.parseURLResponse = exports.parseQueryResponse = exports.generatePlatformPKCE = exports.generatePKCE = void 0;
const jose_1 = require("jose");
var pkce_1 = require("./pkce");
Object.defineProperty(exports, "generatePKCE", { enumerable: true, get: function () { return pkce_1.generate; } });
Object.defineProperty(exports, "generatePlatformPKCE", { enumerable: true, get: function () { return pkce_1.generatePlatform; } });
var response_1 = require("./response");
Object.defineProperty(exports, "parseQueryResponse", { enumerable: true, get: function () { return response_1.parseQueryResponse; } });
Object.defineProperty(exports, "parseURLResponse", { enumerable: true, get: function () { return response_1.parseURLResponse; } });
var OpenIDConfiguration_1 = require("./OpenIDConfiguration");
Object.defineProperty(exports, "OpenIDConfigurationManager", { enumerable: true, get: function () { return OpenIDConfiguration_1.OpenIDConfigurationManager; } });
function buildLogoutURL(configuration, options) {
    const url = new URL(configuration.end_session_endpoint);
    for (const [k, v] of Object.entries(options)) {
        if (v === undefined || v === null)
            continue;
        url.searchParams.set(k, v);
    }
    return url;
}
exports.buildLogoutURL = buildLogoutURL;
function buildAuthorizeURL(configuration, options) {
    const url = new URL(configuration.authorization_endpoint);
    url.searchParams.set('client_id', configuration.client_id);
    url.searchParams.set('scope', options.scope ? options.scope : 'openid');
    for (const [k, v] of Object.entries(options)) {
        if (k === 'acr_values')
            continue;
        if (v === undefined || v === null)
            continue;
        url.searchParams.set(k, v);
    }
    if (options.acr_values) {
        url.searchParams.set('acr_values', Array.isArray(options.acr_values) ? options.acr_values.join(' ') : options.acr_values);
    }
    return url;
}
exports.buildAuthorizeURL = buildAuthorizeURL;
function parseAuthorizeOptionsFromUrl(input) {
    const url = typeof input === "string" ? new URL(input) : input;
    const acr_values = url.searchParams.get('acr_values');
    return {
        domain: url.host,
        client_id: url.searchParams.get('client_id'),
        acr_values: acr_values ? acr_values.split(" ") : undefined,
        redirect_uri: url.searchParams.get('redirect_uri') || undefined,
        response_type: url.searchParams.get('response_type') || undefined,
        response_mode: url.searchParams.get('response_mode') || undefined,
        code_challenge: url.searchParams.get('code_challenge') || undefined,
        code_challenge_method: url.searchParams.get('code_challenge_method') || undefined,
        state: url.searchParams.get('state') || undefined,
        login_hint: url.searchParams.get('login_hint') || undefined,
        ui_locales: url.searchParams.get('ui_locales') || undefined,
        scope: url.searchParams.get('scope') || undefined,
        nonce: url.searchParams.get('nonce') || undefined,
        prompt: url.searchParams.get('prompt') || undefined
    };
}
exports.parseAuthorizeOptionsFromUrl = parseAuthorizeOptionsFromUrl;
function codeExchange(configuration, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const body = new URLSearchParams();
        body.append('grant_type', "authorization_code");
        body.append('code', options.code);
        body.append('client_id', configuration.client_id);
        body.append('redirect_uri', options.redirect_uri);
        if ("code_verifier" in options)
            body.append('code_verifier', options.code_verifier);
        if ("signingKey" in options) {
            body.append('client_assertion_type', 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer');
            const jwt = yield new jose_1.SignJWT({ 'sub': configuration.client_id })
                .setProtectedHeader({ alg: 'RS256' })
                .setIssuedAt()
                .setIssuer(configuration.client_id)
                .setAudience(configuration.issuer)
                .setExpirationTime('5m')
                .sign(options.signingKey);
            body.append('client_assertion', jwt);
        }
        const response = yield fetch(configuration.token_endpoint, {
            method: 'POST',
            cache: 'no-store',
            redirect: 'manual',
            headers: Object.assign(Object.assign({ 'Content-Type': 'application/x-www-form-urlencoded' }, ("client_secret" in options ? {
                Authorization: "Basic " + btoa(`${encodeURIComponent(configuration.client_id)}:${options.client_secret}`)
            } : {})), { 'cache-control': 'no-cache, no-store, must-revalidate' }),
            body: body.toString()
        });
        const payload = yield response.json();
        if (payload.error)
            return { error: payload.error, error_description: payload.error_description };
        return { id_token: payload.id_token, access_token: payload.access_token };
    });
}
exports.codeExchange = codeExchange;
function userInfo(configuration, accessToken) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(configuration.userinfo_endpoint, {
            method: 'GET',
            cache: 'no-store',
            redirect: 'manual',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'cache-control': 'no-cache, no-store, must-revalidate'
            },
        });
        const payload = yield response.json();
        if (payload.error)
            return { error: payload.error, error_description: payload.error_description, state: payload.state };
        return payload;
    });
}
exports.userInfo = userInfo;
//# sourceMappingURL=index.js.map